{
  "copySuccess": "Đã sao chép",
  "downloadSuccess": "Đã tải xuống",
  "downloadFailed": "Không thể tải xuống",
  "serverError": "Máy chủ gặp lỗi. Vui lòng thử lại sau.",
  "refresh": "Làm mới",
  "operationTimedOut": "Thao tác đã hết thời gian. Vui lòng thử lại.",
  "noContent": "Chưa có nội dung",
  "returnHome": "Về trang chủ",
  "setTransactionPassword": "Vui lòng đặt mật khẩu giao dịch trước",
  "setTransactionPasswordDescription": "Vui lòng đặt mật khẩu giao dịch trước khi tiếp tục dùng phương thức này.",
  "gotIt": "Đã hiểu",
  "goToSettings": "Đi tới cài đặt",
  "securityVerification": "Xác minh bảo mật",
  "confirm": "Xác nhận",
  "chooseFromLibrary": "Chọn từ thư viện ảnh",
  "takePhoto": "Chụp ảnh",
  "cancel": "Hủy",
  "chooseAnotherVideo": "Chọn video khác",
  "startAppeal": "Khiếu nại",
  "amountMismatch": "Số tiền không khớp",
  "complete": "Hoàn tất",
  "invalidVideoFormat": "Định dạng video không hợp lệ",
  "videoTooLarge": "Kích thước video vượt quá giới hạn 200MB",
  "uploadVideoProof": "Tải lên bằng chứng video",
  "videoUploadHint": "Video tải lên không được vượt quá 200MB; hỗ trợ MP4, AVI, MOV.",
  "currentLevel": "Cấp hiện tại",
  "levelValidUntil": "Cấp có hiệu lực đến",
  "depositAddressLoadFailed": "Không thể lấy địa chỉ",
  "deposit": "Nhận tiền",
  "depositNotice": "Lưu ý",
  "depositNoticePrefix": "Địa chỉ và mã QR này chỉ hỗ trợ nhận",
  "depositNoticeSuffix": ". Chuyển sai loại có thể không lấy lại được và nền tảng không bồi hoàn. Vui lòng xác nhận loại tiền cần chuyển.",
  "allNotificationsRead": "Đã đánh dấu tất cả là đã đọc",
  "notifications": "Thông báo",
  "markAllRead": "Đọc tất cả",
  "noNotifications": "Chưa có thông báo",
  "settings": "Cài đặt",
  "language": "Ngôn ngữ",
  "pricingCurrency": "Đồng tiền định giá",
  "appNotifications": "Thông báo ứng dụng",
  "devicePermissions": "Quyền thiết bị",
  "notificationPermissionDescription": "Nếu tắt, bạn sẽ không nhận được cập nhật đơn hàng hoặc tin nhắn hỗ trợ.",
  "enabled": "Đã bật",
  "general": "Chung",
  "scanToPay": "Quét để thanh toán",
  "unsupportedQrCode": "Mã QR không được hỗ trợ",
  "scanQrCode": "Quét mã QR",
  "scanQrFromLibrary": "Quét mã QR từ thư viện ảnh",
  "qrCodeNotFound": "Không tìm thấy mã QR",
  "photoLibrary": "Thư viện ảnh",
  "cameraUnavailable": "Không thể sử dụng máy ảnh",
  "cameraPermissionDescription": "Chưa bật quyền máy ảnh. Bạn có thể thay đổi trong Cài đặt.",
  "invalidPaymentLink": "Liên kết thanh toán không hợp lệ",
  "scanToPayHint": "Dùng ứng dụng web {{brand}} để quét mã QR và hoàn tất thanh toán",
  "paymentQrExpired": "Mã QR thanh toán đã hết hạn",
  "signInToPayInBrowser": "Đăng nhập để thanh toán trong trình duyệt",
  "visitOfficialWebsite": "→Vào trang web chính thức của {{brand}}",
  "approximate": "≈ {{amount}}",
  "version": "Phiên bản {{version}}",
  "buildCommit": "Bản dựng commit",
  "clearInput": "Xóa nội dung nhập",
  "showPassword": "Hiện mật khẩu",
  "hidePassword": "Ẩn mật khẩu",
  "runtimeEnvironment": {
    "production": "Môi trường sản xuất",
    "staging": "Môi trường thử nghiệm",
    "localhost": "Phát triển cục bộ"
  },
  "copying": "Đang sao chép",
  "copyFailed": "Sao chép thất bại",
  "copy": "Sao chép",
  "backendEnvironment": "Môi trường backend",
  "environmentSwitchDescription": "Chuyển môi trường sẽ xóa trạng thái đăng nhập hiện tại.",
  "tradingDisabled": "Hệ thống đang bảo trì, tính năng giao dịch tạm thời không khả dụng. Vui lòng thử lại sau.",
  "diagnostics": {
    "cancelled": "Đã hủy",
    "preparing": "Đang chuẩn bị",
    "exportFailed": "Xuất thất bại",
    "save": "Lưu",
    "share": "Chia sẻ",
    "saved": "Đã lưu",
    "shared": "Đã mở chia sẻ",
    "title": "Nhật ký chẩn đoán",
    "exportLog": "Xuất nhật ký chẩn đoán",
    "copyLog": "Sao chép nhật ký chẩn đoán",
    "androidDescription": "Bạn có thể sao chép nhật ký gần đây hoặc lưu toàn bộ tệp",
    "iosDescription": "Xuất tệp và gửi cho bộ phận hỗ trợ {{brand}}"
  },
  "languageName": {
    "zh-Hans": "Tiếng Trung giản thể",
    "zh-Hant": "Tiếng Trung phồn thể",
    "th-TH": "Tiếng Thái",
    "vi-VN": "Tiếng Việt"
  }
}
